/* import __COLOCATED_TEMPLATE__ from './information-step.hbs'; */
import { CLIENT_TYPE_KEYS } from 'client-portal/utils/prescreener/constants';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './information-step.module.scss';

export default class RequestStepsInformationStep extends Component {
  styles = styles;

  @service currentPractice;
  @service prescreener;

  get modelClientTypeKey() {
    if (!this.prescreener.featurePrescreenerV2) {
      return null;
    }
    return CLIENT_TYPE_KEYS[this.args.model?.clientType] || this.args.model?.clientType;
  }
}
